export const BASE_URL = "https://researchhubbe.onrender.com/"